(function () {
  'use strict';

  /* @ngdoc object
   * @name cabinPerformanceComment
   * @description
   *
   */
  angular
    .module('cabinPerformanceComment', [
      'ui.router'
    ]);
}());
